import type { i18n as i18nType } from 'i18next';

import { LANGUAGE } from './constants';

export const FALLBACK_LANGUAGE = LANGUAGE.en;

const updateBeamerLanguage = (language: LANGUAGE) => {
  if (window.Beamer) {
    window.Beamer.update({ language });
    window.Beamer.destroy();
    window.Beamer.init();
  }
};

export const setCurrentLanguage = async (
  language: LANGUAGE,
  i18n: Pick<i18nType, 'changeLanguage'>,
) => {
  updateBeamerLanguage(language);
  await i18n.changeLanguage(language);
};

// We only use the first 2 characters because the format can be `en-GB` or `de-DE`.
let browserLanguage = navigator.language.slice(0, 2);

export const overwriteBrowserLanguage = (language: LANGUAGE) => {
  browserLanguage = language;
};

export const detectLanguage = (): LANGUAGE => {
  const detectedLanguage = Object.values(LANGUAGE).find((language) => language === browserLanguage);
  if (detectedLanguage) {
    return detectedLanguage;
  }

  return FALLBACK_LANGUAGE;
};
